var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStuck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5.5V2.5H5.5V5.5H4.5Z",
  fill: "#1B1B1B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7.5C4.65482 7.5 4.375 7.22018 4.375 6.875C4.375 6.52982 4.65482 6.25 5 6.25C5.34518 6.25 5.625 6.52982 5.625 6.875C5.625 7.22018 5.34518 7.5 5 7.5Z",
  fill: "#1B1B1B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10ZM5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z",
  fill: "#1B1B1B"
})));
export { SvgStuck as ReactComponent };
export default __webpack_public_path__ + "assets/b8957abf.svg";